<template>
<v-container app :fluid="true" class="pt-0">
    <v-row>
        <v-col cols="6">
            <v-text-field
                v-model="search"
                append-icon="fas fa-search"
                label="Buscar proveedor"
                solo
                dense
                hide-details
            ></v-text-field>
        </v-col>
        <v-col cols="6">
            <v-btn @click="handleNewProvider" 
                rised 
                color="indigo" 
                dark
                class="float-right wost-btn-new"
                v-if="verifyPermission('crear_proveedores')">
                <v-icon dark left size="12">fas fa-plus</v-icon>Nuevo Proveedor
            </v-btn>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="12" class="pt-0">
            <v-card>
                <v-data-table
                    class="wost-table"
                    :headers="headers"
                    :items="providers"
                    item-key="document"
                    :search="search"
                    height="65vh"
                    v-if="verifyPermission('listar_proveedores')"
                >
                    <template v-slot:item.name="{item}">
                        {{ item.name }}
                        <span :class="'status-' + item.status.toLowerCase()">{{ item.status }}</span>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <div class="datatable-cell-wrapper">
                            <a href="#" 
                                title="Editar" 
                                class="btn-actions btn-edit"
                                    @click="editProvider(item)"
                                    v-if="verifyPermission('actualizar_proveedores')">
                                <v-icon color="amber" size="16">fas fa-pencil-alt</v-icon>
                            </a>
                            &nbsp;
                            <a v-if="item.status  === 'activo' && verifyPermission('inactivar_proveedores')" 
                                href="#" 
                                title="Inactivar" 
                                class="btn-actions btn-delete" 
                                @click="changeStatus(item, 'inactivar')">
                                <v-icon color="red darken-1" size="16">fas fa-minus-circle</v-icon>
                            </a>
                            <a v-else-if="item.status  === 'inactivo' && verifyPermission('activar_proveedores')"
                                href="#" 
                                title="Activar" 
                                class="btn-actions btn-delete" 
                                @click="changeStatus(item, 'activar')">
                                <v-icon color="green darken-1" size="16">fas fa-check-circle</v-icon>
                            </a>
                        </div>
                    </template>
                </v-data-table>
            </v-card>
        </v-col>
    </v-row>
    <create-provider ref="createProvider"></create-provider>
</v-container>
    
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import CreateProvider from '../../components/Providers/CreateProvider'
import {APIService} from '@/APIService';

const apiService = new APIService();

export default {
    name: 'Providers',
    components: {
        CreateProvider
    },
    data() {
        return {
            search: '',
            headers: [
                { text: 'RUC', value: 'document', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Nombre', value: 'name', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Teléfono', value: 'phone', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Email', value: 'email', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Dirección', value: 'address', align: 'left', sortable: false, class: 'header-table' },
                { text: 'Acciones', value: 'action', sortable: false, class: 'header-table', width: 35 }
            ],
        }
    },
    computed: {
        ...mapState('provider', [
            'providers'
        ])
    },
    methods: {
        ...mapActions('provider', [
            'getProviders',
            'runSetProvider'
        ]),
        editProvider(provider){
            this.runSetProvider(provider)
            this.$refs.createProvider.showForm('Modificar datos de proveedor', 'update')
        },
        handleNewProvider(){
            this.$refs.createProvider.showForm('Nuevo proveedor', 'create')
        },
        changeStatus(provider, status) {
            this.$swal({
                    title: "¿Desea confirmar?",
                    text: "Confirma que desea " + status + " el proveedor",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Confirmar",
                    cancelButtonText: "Cancelar",
                }).then((result) => {
                    if(result.value){
                        if(result.value === true){
                            apiService.changeStatusProvider(provider.id).then((response) => {
                                this.getProviders()
                                this.$notify({
                                    group: 'foo',
                                    type: 'success',
                                    title: 'RESULTADO DE CAMBIO DE ESTADO DEL PROVEEDOR',
                                    text: 'Se cambió el estado del proveedor de forma exitosa.'
                                })
                            });
                        }
                    }                    
                })
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        }
    },
    mounted() {
        this.getProviders()
    }

}
</script>

<style>

</style>